import {Component, inject, OnInit} from '@angular/core';
import {
  FrontendNavigationComponent
} from '../../../../frontend/player-frontend/frontend-navigation/frontend-navigation.component';
import {MenuItem} from 'primeng/api';
import {RouterOutlet} from '@angular/router';
import {PLAYER_PREFIX_FULL} from '../../../player.routes';
import {PlayerAuthenticationService} from '../../../service/player-authentication.service';

@Component({
  selector: 'app-player-profile-statistics',
  standalone: true,
  imports: [
    FrontendNavigationComponent,
    RouterOutlet
  ],
  templateUrl: './player-profile-statistics.component.html',
  styleUrl: './player-profile-statistics.component.scss'
})
export class PlayerProfileStatisticsComponent implements OnInit
{
  private playerAuthenticationService = inject(PlayerAuthenticationService);

  navigationItems: MenuItem[];

  ngOnInit(): void
  {
    this.initNavigationItems();
  }

  private initNavigationItems(): void
  {
    const isPro = this.playerAuthenticationService.isProVersion();
    console.log('isPro: ' + isPro);

    this.navigationItems = [
      {
        label: 'MATCHES',
        routerLink: PLAYER_PREFIX_FULL + '/profile/statistics/matches',
        url: 'matches',
        icon: 'pi pi-list',
        iconClass: isPro ? '' : 'PRO'
      },
      {
        label: 'TABLE',
        routerLink: PLAYER_PREFIX_FULL + '/profile/statistics/table',
        url: 'table',
        icon: 'pi pi-table',
      },
      {
        label: 'GRAPH',
        routerLink: PLAYER_PREFIX_FULL + '/profile/statistics/graph',
        url: 'graph',
        icon: 'pi pi-chart-bar',
        iconClass: isPro ? '' : 'PRO'
      }
    ];
    console.log('navigationItems:', this.navigationItems);
  }
}
